import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useOfferConfirmPaymentMutation } from '../../hooks';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

interface OfferConfirmPaymentModalType {
  data: {
    id: string;
    number: string;
    price: number;
  }[];
  isPaid: boolean;
  isInstallment: boolean;
  submitClick: () => void;
  open: () => void;
}

export const offerConfirmPaymentModal: OfferConfirmPaymentModalType = {
  data: [],
  isPaid: true,
  isInstallment: false,
  submitClick: () => null,
  open: () => null,
};

export const OfferConfirmPaymentModal = () => {
  const { mutate } = useOfferConfirmPaymentMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    offerConfirmPaymentModal.open = () => {
      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    offerConfirmPaymentModal.data = [];
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      offerConfirmPaymentModal.data.map((item) => ({
        id: item.id,
        isConfirm: offerConfirmPaymentModal.isPaid || offerConfirmPaymentModal.isInstallment,
        isInstallment: offerConfirmPaymentModal.isInstallment,
      })),
      {
        onSuccess: () => {
          setOpen(false);
          offerConfirmPaymentModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.OFFER.ERROR.NOT_CONFIRMED_PAYMENT, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'offer-confirm-payment-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {offerConfirmPaymentModal.isInstallment
            ? i18n.t('pages.modal.offerPaymentInstallment')
            : offerConfirmPaymentModal.isPaid
            ? i18n.t('pages.modal.offerPaymentReceived')
            : i18n.t('pages.modal.offerPaymentNotReceived')}
        </Typography>
        {offerConfirmPaymentModal.data.map((item, i) => (
          <Typography key={i} variant={'textM'}>
            {item.number}
          </Typography>
        ))}
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.confirm')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
